/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ outcome: NonNullable<unknown> }} Dashboard_Task_OutcomeInputs */

const en_dashboard_task_outcome = /** @type {(inputs: Dashboard_Task_OutcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Outcome: ${i?.outcome}`)
};

const pt_br2_dashboard_task_outcome = /** @type {(inputs: Dashboard_Task_OutcomeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resultado: ${i?.outcome}`)
};

/**
* | output |
* | --- |
* | "Outcome: {outcome}" |
*
* @param {Dashboard_Task_OutcomeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_task_outcome = /** @type {((inputs: Dashboard_Task_OutcomeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Task_OutcomeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_task_outcome(inputs)
	return pt_br2_dashboard_task_outcome(inputs)
});